export var mapCSVDataToFormValuesModel = function (csvData) {
    return csvData.map(function (user) {
        var _a, _b, _c, _d;
        var formattedUser = formatUserKeys(user);
        return {
            firstName: (_a = formattedUser['first name']) === null || _a === void 0 ? void 0 : _a.toString().trim(),
            lastName: (_b = formattedUser['last name']) === null || _b === void 0 ? void 0 : _b.toString().trim(),
            email: (_c = formattedUser.email) === null || _c === void 0 ? void 0 : _c.trim(),
            role: (_d = formattedUser.role) === null || _d === void 0 ? void 0 : _d.trim(),
        };
    });
};
export var mapFieldsToCSVModel = function (fields) {
    return fields.map(function (_a) {
        var firstName = _a.firstName, lastName = _a.lastName, role = _a.role, email = _a.email;
        return ({
            'First Name': firstName,
            'Last Name': lastName,
            Email: email,
            Role: role,
        });
    });
};
export var convertStringToBlobCSV = function (csv) {
    return window.URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
};
var formatUserKeys = function (obj) {
    return Object.entries(obj).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        var userObj = acc;
        var formattedKey = key.toLowerCase().trim();
        if (formattedKey === 'firstname')
            formattedKey = 'first name';
        if (formattedKey === 'lastname')
            formattedKey = 'last name';
        userObj[formattedKey] = value;
        return userObj;
    }, {});
};
export var removeDuplicateUsers = function (existingUserList, usersValues) {
    var emails = new Set(existingUserList === null || existingUserList === void 0 ? void 0 : existingUserList.map(function (user) { var _a; return (_a = user.email) === null || _a === void 0 ? void 0 : _a.toLowerCase(); }));
    return usersValues.filter(function (value) {
        var _a;
        var email = (_a = value === null || value === void 0 ? void 0 : value.email) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (email === undefined)
            return true; // Include empty emails
        if (email && !emails.has(email)) {
            emails.add(email);
            return true;
        }
        return false;
    });
};
